"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutableMapRecord = (record, mapper) => {
    let newRecord = record;
    Object.entries(record).forEach(([itemKey, item]) => {
        const mapped = mapper(itemKey, item);
        if (mapped === item) {
            return;
        }
        newRecord = Object.assign(Object.assign({}, newRecord), { [itemKey]: mapped });
    });
    return newRecord;
};
exports.default = immutableMapRecord;
